import React, {useState} from 'react';
import axios from "axios";
import { API_OK, API_URL, DEFAULT_ERROR_TEXT, API_EXCEPTION } from '../../Constants';
import {Trans,  useTranslation } from 'react-i18next';
import {apiErrorMessage, getLang, isValidEmail} from "../../Helper";

import Frame from '../widgets/Frame';
import { useSubmitGuard } from "../../hooks/useSubmitGuard";
import { useCaptcha } from "../../captcha";
import { useEnterSubmit } from '../../hooks/useEnterSubmit';

export function ResetPassword() {
    const [state, setState] = useState({ email: "", errors: {}, message: null });

    
    const { t } = useTranslation();
    // One send per click: the mail costs something, and a double click sends two.
    const submit = useSubmitGuard();
    /**
     * הקאפצ'ה. פעילה רק כשההגדרה הגיעה מהשרת, ומה שנשלח נבדק שם בלי קשר למסך.
     */
    const captcha = useCaptcha('passwordReset');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!validateForm()) {
            let errorMessage = DEFAULT_ERROR_TEXT;

            let config = {'headers': {"lang": getLang()}};
          
            const data = {email: state.email.trim()};

            // הטוקן מצורף כאן, כדי שהפעולה שהוא נוצר עבורה תיקבע במקום אחד.
            const payload = await captcha.attach(data);
            // אין טוקן - אין מה לשלוח. ההסבר כבר מצויר על המסך.
            if (!payload) {
                return;
            }
        
            try {
                const reply = await submit.run(() => axios.post(API_URL + 'sendResetPasswordEmail', payload, config));
                if (!reply) {
                    return;
                }
                //const reply = {data: {responseStatus : API_EXCEPTION, message: 'HEEEEEEELLLLP'}};
                if(reply.hasOwnProperty('data') && reply.data.hasOwnProperty('responseStatus') && reply.data.responseStatus === API_OK){
                    setState({
                        ...state,
                        // מותנה, מאותו טעם שב-`RestoreUsername`: התשובה אחידה לכל
                        // כתובת, ולכן ההודעה אינה יכולה לקבוע שנשלח משהו.
                        message: t("Reset link sent if registered")
                    });
                }else{
                    if((reply.data.responseStatus === API_EXCEPTION) && (reply.data.hasOwnProperty("message"))){
                        errorMessage = apiErrorMessage(reply.data, t);
                    }
                    // `message: null` במפורש: `state` כאן הוא הצילום שנלכד לפני
                    // `validateForm`, כלומר בלעדיו הודעת ההצלחה הקודמת חוזרת ומוצגת
                    // יחד עם השגיאה - "נשלח לך מייל" מעל "יותר מדי ניסיונות".
                    setState({
                        ...state,
                        message: null,
                        errors: {server_error: errorMessage}
                    });
                };
            } catch (e) {
                setState({
                    ...state,
                    message: null,
                    errors: {server_error: errorMessage}
                });
            }
        }

    };

    const handleChange = (e) => {
        setState({
            ...state,
            [e.target.id]: e.target.value,
            errors: {},
            message: null
        });
    };

    /**
     * מחזיר `true` כשיש שגיאות - ומכאן ש-`handleSubmit` שולח כשהתשובה שלילית.
     * שם מבלבל שנשאר כפי שהיה; מה שנוסף כאן הוא בדיקת הצורה של הכתובת, שקודם
     * הייתה רק בשרת ורק אחרי סבב שלם.
     */
    const validateForm = () => {
        const errors = {};
        const email = state.email.trim();
        if (!email) {
            errors['email'] = 'Email is required';
        } else if (!isValidEmail(email)) {
            errors['email'] = 'invalid_email';
        }

        setState({
            ...state,
            errors: errors,
            message: null
        });

        return Object.keys(errors).length > 0;
    };


    /**
     * Enter ממשיך לשלב הבא. ראה `useEnterSubmit` - הפעולה הראשית של המסך אינה
     * כפתור שליחה אלא `div`, ולכן הדפדפן אינו שולח כאן דבר מעצמו.
     */
    useEnterSubmit((e) => handleSubmit(e), !submit.busy);

    return (
            <Frame>
                <div className='main main-reset-password'>
                    <div className='main-top'>
                        <h1>{t("Reset password")}</h1>
                    </div>
                    <div className='main-body'>
                        <div className='right-main'>
                            <div className='right-main-inner'>
                                <h2>{t("No problem at all. We will help you to reset the password in a few easy steps.")}</h2>
                                <div className='mt30 input blue-border'><input className={state.errors.email?"error":""} type="text" id="email" placeholder={t("Email address")} onChange={(e) => handleChange(e)} /></div>
                                {captcha.node}
                                <div {...submit.buttonProps({base: 'button button-space-between button-teal'})} onClick={(e) => handleSubmit(e)}>  <div className='mr20'>{submit.busy ? t("Sending...") : t("Send me the password reset link")}</div> {submit.busy ? <span className='button-spinner ml20' /> : <img src='/images/less-than-white.png' className='ml20 button-icon less-than-icon' alt=''/>} </div>
                                
                                {state.message?<h2 className='mt10 teal'><Trans i18nKey={state.message} /></h2>:""}

                                <h2 className='mt40 teal'><Trans i18nKey="After pressing the button, we will send you an email with the instruction for resetting your passowrd. Please make sure to also check your spam folder in case that you didn't receive the email within a few minutes." /></h2>

                                {Object.entries(state.errors).map(([key, msg]) => (
                                    <h2 key={key} className='mt20 error'><Trans i18nKey={msg} /></h2>
                                ))}
                            </div>
                        </div>    
                        <div className='left-main'>
                            <img src='/images/person-phone.png' className='content-logo' alt=''/>
                        </div>
                    </div>
                </div>
            </Frame>
    );
}